import { initializeLogger } from '@seamless/logger'

const logger = initializeLogger('NOTIFICATIONS-HUB')

export default logger
